import Api from "../axios";

export default async function getPresentMonthLeave(employeeId) {
  return await Api.get(`/present_month_leaves?employee_id=${employeeId}`);
}